import { userService } from '../../services/auth-api.service.js'
import router from '../../router.js'

// const user = JSON.parse(localStorage.getItem('user'));
const user = null
const authenticationInitialState = user
  ? { status: { loggedIn: true }, user,errorMessage: '', lastPasswordReset: null }
  : { status: {}, user: null,errorMessage: '', lastPasswordReset: null }

const getTimestampSeconds = () => Math.round(+new Date()/1000)
const secondsPassed = (timestamp, seconds) => {
  let now = getTimestampSeconds()
  if (seconds == null || now - timestamp >= seconds)
    return true
  else
   return false
}

export const authenticationModule = {
  namespaced: true,
  state: authenticationInitialState,
  getters: {
    getErrors: state => state.errorMessage,
    getLastPasswordReset: state => state.lastPasswordReset,
    canResetPassword: state => {
      return secondsPassed(state.lastPasswordReset, 300)
    }
  },
  actions: {
    login ({ dispatch, commit }, { resellerId, username, password, returnurl }) {
      commit('resetError');
      commit('loginRequest', { resellerId, username })

      userService.login(resellerId, username, password)
        .then(
          user => {
            commit('loginSuccess', user)

            if (returnurl) {
              router.push(returnurl)
            } else {
              router.push('/')
            }
          },
          error => {
            commit('loginFailure', error)
            dispatch('alert/error', error, { root: true })
          }
        )
    },
    register ({ dispatch, commit }, { resellerId, username, autoLogin, returnurl }) {
      commit('resetError');
      commit('registerRequest', { resellerId, username })

      return userService.register(resellerId, username, autoLogin)
        .then(
          user => {
            if (autoLogin && autoLogin === true) {
              commit('registerLoginSuccess', user)
            }
            commit('registerSuccess', user)

            if (returnurl) {
              router.push(returnurl)
            } else {
              router.push('/')
            }
          },
          error => {
            commit('registerFailure', error)
            dispatch('alert/error', error, { root: true })
          }
        )
    },
    logout ({ dispatch, commit }) {
      commit('resetError');
      // userService.logout();
      dispatch('resetStore', null, { root: true })
      commit('logout')
    },
    resetPassword ({ getters, dispatch, commit }, { resellerId, username }) {
      commit('resetError');
      //console.log('-pr: ', getters.getLastPasswordReset)
      if (secondsPassed(getters.getLastPasswordReset, 300))
        userService.resetPassword(resellerId, username)
          .then(
            user => {            
              //router.push('/login')
              router.push({ path: 'login', query: { new_password: 'true' }})
              commit('lastPasswordReset')
            },
            error => {throw Error(error)}
          ).catch(err => {           
            commit('displayError', 'Please check the details entered.')
          });
      else
        commit('displayError', 'You have requested to reset your password within the last 5 minutes, please check your Inbox for an email containing your new password.')
    },
    changePassword ({ dispatch, commit }, { resellerId, username, password, newPassword }) {
      userService.changePassword(resellerId, username, password, newPassword)
        .then(
          user => {
            router.push('/myclaims')
          },
          error => {}
        )
    },
    resetErrorMessage ({commit}) {
      commit('resetError', '')
    }
  },
  mutations: {
    registerRequest (state, user) {
      state.status = { registering: true }
      state.user = user
    },
    registerSuccess (state, user) {
      state.status = { registered: true }
      state.user = user
    },
    registerLoginSuccess (state, user) {
      state.status = { registered: true, loggedIn: true }
      state.user = user
    },
    registerFailure (state) {
      state.status = {}
      state.user = null
    },
    loginRequest (state, user) {
      state.status = { loggingIn: true }
      state.user = user
    },
    loginSuccess (state, user) {
      state.status = { loggedIn: true }
      state.user = user
    },
    loginFailure (state) {
      state.status = { failure: true }
      state.user = null
    },
    logout (state) {
      state.status = {}
      state.user = null
    },
    displayError (state, error) {
      state.errorMessage = error
    },
    resetError (state) {
      state.errorMessage = ''
    },
    lastPasswordReset (state) {
      state.lastPasswordReset = getTimestampSeconds();
    },
    clearLastPasswordReset (state) {
      state.lastPasswordReset = null;
    }
  }
}
